import SpotGuidePage from './SpotGuidePage';

export default SpotGuidePage;
